import { useState, useCallback } from 'react';
import { ToggleButton, ToggleButtonGroup, ToggleButtonProps } from '@mui/material';
import Iconify from 'src/components/iconify';
import CasTabsPanel from './_internal/CasTabsPanel';

interface IButtonItem {
  label: string;
  icon?: string;
  children: React.ReactNode;
  color?: ToggleButtonProps['color'];
}

interface CasTabButtonsViewProps {
  buttonList: IButtonItem[];
}

export default function CasTabButtonsView({ buttonList }: CasTabButtonsViewProps) {
  const [activeTab, setActiveTab] = useState('');

  const handleTabChange = useCallback((_: React.MouseEvent<HTMLElement>, newValue: string) => {
    setActiveTab(newValue);
  }, []);

  return (
    <>
      <ToggleButtonGroup exclusive value={activeTab} onChange={handleTabChange} color="primary">
        {buttonList.map(({ label, color, icon }) => (
          <ToggleButton key={label} value={label} color={color}>
            {icon && <Iconify icon={icon} width={20} height={20} />}
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {activeTab && buttonList.map(({ label, children }) => (
        <CasTabsPanel value={activeTab} index={label} key={label}>
          {children}
        </CasTabsPanel>
      ))}
    </>
  );
}
